import CustomBrandsList from "./List";
import CustomBrandsEdit from "./Edit";
export default [
    {exact: true, path: "/custombrands", component: CustomBrandsList},
    { path: "/custombrand/c", component: CustomBrandsEdit },
    { path: "/custombrand/e/:brandName", component: CustomBrandsEdit }
];
